var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.bot-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bot-svg",
    d: "M0.8,7.8c0-2.2,1.8-4,4-4h6.5c2.2,0,4,1.8,4,4v3.5c0,2.2-1.8,4-4,4H4.8c-2.2,0-4-1.8-4-4V7.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bot-svg",
    d: "M8,3.2V0.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bot-svg",
    d: "M6.2,8c0,0.7-0.6,1.2-1.2,1.2S3.8,8.7,3.8,8S4.3,6.8,5,6.8S6.2,7.3,6.2,8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bot-svg",
    d: "M12.2,8c0,0.7-0.6,1.2-1.2,1.2S9.8,8.7,9.8,8s0.6-1.2,1.2-1.2S12.2,7.3,12.2,8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bot-svg",
    d: "M6.8,12.2h2.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.bf815fd1f14a384eaea75ab73f93a996.svg";
export { ForwardRef as ReactComponent };